module.exports = __webpack_public_path__ + "img/ikon-sv.262eafed.png";